module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    class: {
      collapsed: !_vm.showControls
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_vm._v("БутСервис")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showControls) ? _c('nav', [_c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'all-clients'
      }
    }
  }, [_c('i', {
    staticClass: "icon-stopwatch"
  }), _vm._v(" Клиенты\n        ")])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'transactions'
      }
    }
  }, [_c('i', {
    staticClass: "icon-customers"
  }), _vm._v(" Транзакции\n        ")])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'claims'
      }
    }
  }, [_c('i', {
    staticClass: "icon-customers"
  }), _vm._v(" Заявки\n        ")])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_c('i', {
    staticClass: "icon-settings"
  }), _vm._v(" Настройки\n        ")])], 1), _vm._v(" "), (_vm.showAdditional) ? _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'styleguide'
      }
    }
  }, [_c('i', {
    staticClass: "icon-settings"
  }), _vm._v(" Styleguide\n        ")])], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showControls) ? _c('div', {
    staticClass: "account"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('span', [_vm._v(_vm._s(_vm.user.username))]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Выйти")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 text-right"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": require("../assets/img/ava2.png"),
      "alt": ""
    }
  })])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6f55dec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 714
// module chunks = 0